<script>
import fadeInUp from '../components/animations/FadeInUp.vue';
import imageItem from '../components/ImageItem.vue';
import liveBlinker from '../components/LiveBlinker.vue';
import magnetic from '../components/Magnetic.vue';
import parallaxBg from '../components/ParallaxBg.vue';
import videoBackground from '../components/videoBackground.vue';

export default {
    components: {
        fadeInUp,
        imageItem,
        liveBlinker,
        magnetic,
        parallaxBg,
        videoBackground
    },

    mounted() {
        this.parallax();
    },

    methods: {
        parallax() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.container,
                    scrub: true
                }
            });

            parallax
                .fromTo(
                    this.$refs.vertRight,
                    {
                        y: '-15%'
                    },
                    {
                        y: '45%',
                        ease: 'none'
                    }
                )
                .fromTo(
                    this.$refs.vertLeft,
                    {
                        y: '15%'
                    },
                    {
                        y: '-85%',
                        ease: 'none'
                    },
                    '<0'
                );
        }
    }
};
</script>
